import Vue from 'vue';
import axios from 'axios';
import _reject from 'lodash/reject';
import { request_mutations, request_state } from '../utils/store';
import { TOPIC_MEMBERS_LIST, TOPIC_MEMBERS_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        create: request_state(),
        remove: request_state(),
        update: request_state(),
    },
    mutations: {
        ...request_mutations('topic_members_list', 'list'),
        ...request_mutations('create_topic_member', 'create'),
        ...request_mutations('remove_topic_member', 'remove'),
        ...request_mutations('update_topic_member', 'update'),

        remove_topic_member(state, { id }) {
            const members = _reject(state.list.data.results, { id });
            Vue.set(state.list.data, 'results', members);
        },
    },
    actions: {
        list({ commit }, { space_id, topic_id }) {
            const url = TOPIC_MEMBERS_LIST
                .replace('{space_id}', space_id)
                .replace('{topic_id}', topic_id);

            commit('topic_members_list_loading');
            return new Promise((resolve) => {
                axios.get(url, auth()).then((response) => {
                    commit('topic_members_list_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('topic_members_list_error', error.response ? error.response.data : {});
                });
            });
        },
        create({ commit }, { space_id, topic_id, data }) {
            const url = TOPIC_MEMBERS_LIST
                .replace('{space_id}', space_id)
                .replace('{topic_id}', topic_id);

            commit('create_topic_member_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_topic_member_success', response.data);
                    resolve(response.data);
                }).catch((error) => {
                    commit('create_topic_member_error', error.response ? error.response.data : {});
                });
            });
        },
        update({ commit }, {
            space_id, topic_id, member_id, data,
        }) {
            const url = TOPIC_MEMBERS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{topic_id}', topic_id)
                .replace('{member_id}', member_id);

            commit('update_topic_member_loading');
            return new Promise((resolve) => {
                axios.put(url, data, auth()).then((response) => {
                    commit('update_topic_member_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('update_topic_member_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, { space_id, topic_id, member_id }) {
            const url = TOPIC_MEMBERS_DETAIL
                .replace('{space_id}', space_id)
                .replace('{topic_id}', topic_id)
                .replace('{member_id}', member_id);

            commit('remove_topic_member_loading');
            axios.delete(url, auth()).then((response) => {
                commit('remove_topic_member_success', response.data);
                commit('remove_topic_member', { topic_id });
            }).catch((error) => {
                commit('remove_topic_member_error', error.response ? error.response.data : {});
            });
        },
    },
};
